import { Uploadable } from '@app/classes/uploadable';
import { DocumentAllowedFileTypes } from '@app/modules/documents-v2/enums/document-allowed-file-types.enum';
import { Role } from '@models/account/role.model';

export class EmployeeDocumentUploadable extends Uploadable {
    /**
     * Roles to be attached to the employee document
     */
    roles: Role[] = [];

    /*
     * We added support for images in SQA-3650 for "View Only" Documents
     */
    protected readonly allowedMimeTypes = ['application/pdf', 'image/jpeg', 'image/png', 'image/gif'];
    protected readonly allowedExtensions = DocumentAllowedFileTypes.acknowledgement.split(',');

    constructor(file: File) {
        super(file);
        this.afterConstruct();
    }

    onRoleChanges(roles: Role[]): void {
        this.roles = roles;
    }

    protected checkIsReadyToUpload(): boolean {
        return true;
    }

    protected setErrors(): void {
        //
    }
}
